<template lang="pug">
  .component-client-action-buttons
    .dropdown-buttons
      button.button.warning(type="button", v-on:click="remove") Delete
</template>
<script type="text/babel">
  import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
  import MaggieHelper from "src/maggieHelper"

  export default {
    name: "TocButtons",
    components: {},
    data() {
      return {
        entity: null
      }
    },
    created() {
    },
    methods: {
      remove: function () {
        this.$confirm('Are you sure?', `Do you really want to <strong>Remove</strong> the <strong>T${this.item.id} toc?</strong>`, () => {
          KeplerBackofficeSdk.tocs.select(this.item).remove(() => {
            MaggieHelper.notification('delete-esit', "Toc removed")
            window.location.reload()
          })
        })
      },
    },
    props: ['item']
  }
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// TocButtons.vue?32df308a